import i18n from '@/i18n/i18n';

export default [
    {
        path: '/warehouse/clients',
        name: 'warehouse-clients',
        component: () => import('@/views/app/warehouse/pages/clients/Index.vue'),
        meta: {
            authRequired: true,
            rule: 'editor',
            can: ['IU RANGES VIEW'],
            breadcrumb: [
                { title: 'Home', url: '/' },
                { title: i18n.messages[i18n.locale].warehouse,url:'/warehouse/clients'},
                { title: i18n.messages[i18n.locale].clients, active: true },
            ]
        }
    },
    {
        path: '/warehouse/client-price/:client/detail',
        name: 'warehouse-client-price-detail',
        component: () => import('@/views/app/warehouse/pages/ranges/Index.vue'),
        meta: {
            authRequired: true,
            rule: 'editor',
            can: ['IU RANGES VIEW'],
            breadcrumb: [
                { title: 'Home', url: '/home' },
                { title: i18n.messages[i18n.locale].warehouse, url: '/warehouse/clients'},
                { title: i18n.messages[i18n.locale].clients, url: '/warehouse/clients' },
                { title: i18n.messages[i18n.locale].ranges, active: true },
            ]
        }
    },
    {
        path: '/warehouse/expense/containers',
        name: 'warehouse-expense-containers',
        component: () => import('@/views/app/warehouse/pages/expense-containers/Index.vue'),
        meta: {
            authRequired: true,
            rule: 'editor',
            can: ['IU PREEXPENSES VIEW'],
            breadcrumb: [
                { title: 'Home', url: '/' },
                { title: i18n.messages[i18n.locale].expenses, url: '/warehouse/expense/containers' },
                { title: i18n.messages[i18n.locale].containers, active: true },
            ]
        }
    },
    {
        path: '/warehouse/expense/pallets',
        name: 'warehouse-expense-pallets',
        component: () => import('@/views/app/warehouse/pages/expense-pallets/Index.vue'),
        meta: {
            authRequired: true,
            rule: 'editor',
            can: ['IU PREEXPENSES VIEW'],
            breadcrumb: [
                { title: 'Home', url: '/' },
                { title: i18n.messages[i18n.locale].expenses, url: '/warehouse/expense/pallets' },
                { title: i18n.messages[i18n.locale].pallets, active: true },
            ]
        }
    },
]
